import "./newsarticle.css";
import { useEffect, useState } from "react";
import NavigationBar from "../../../components/navbar/NavigationBar";
import PageTitle from "../../../components/Page Title/PageTitle";
import "./newsarticle.css";

const Newsarticle = () => {
  const [articleHtml, setArticleHtml] = useState("");
  const [articleTitle, setArticleTitle] = useState("");

  
  const rawSearch = window.location.search;

  const cleanedSearch = rawSearch
    .replace("?utm_source=ingameHub&utm_medium=IngameHub&utm_campaign=IngameHub", "")
    .replace("&utm_source=ingameHub&utm_medium=IngameHub&utm_campaign=IngameHub", "")
    .replace("?utm_source=ingameHub", "");

  const urlParams = new URLSearchParams(cleanedSearch);
  const articleId = urlParams.get("id");

  useEffect(() => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    const trackingString = "utm_source=ingameHub&utm_medium=IngameHub&utm_campaign=IngameHub";

    if (url.search.includes(trackingString)) {
      url.search = url.search
        .replace(`?${trackingString}`, "")
        .replace(`&${trackingString}`, "");
      window.history.replaceState({}, "", url.toString());
    }
  }, []);
  
  useEffect(() => {
    const fetchRSS = async () => {
      try {
        let feed = articleId === "changelog" ? "https://static.hng-group.com/category/development/changelogs/feed/index.html" : "https://static.hng-group.com/category/news/feed/index.html"
        console.log(feed)
        const response = await fetch(feed);
        const text = await response.text();
  
        const parser = new DOMParser();
        const xml = parser.parseFromString(text, "application/xml");
  
        if (xml.querySelector("parsererror")) {
           setArticleHtml("<p>Invalid RSS feed format.</p>");
          return;
        }
  
        const items = Array.from(xml.querySelectorAll("item"));
   
        const matchedItem = items.find((item) => {
          const guid = item.querySelector("guid")?.textContent?.trim();
           return guid === articleId;
        });
  
        if (matchedItem) {
          const encoded = matchedItem.getElementsByTagName("content:encoded")[0];
          const encodedContent = encoded ? encoded.textContent : "<p>No content found.</p>";
          setArticleTitle(matchedItem.getElementsByTagName("title")[0].textContent)
           setArticleHtml(encodedContent);
        } else {
           setArticleHtml("<p>Article not found.</p>");
        }
      } catch (error) {
         setArticleHtml("<p>Failed to load article content.</p>");
      }
    };
  
    if (articleId) {
      fetchRSS();
    }
  }, [articleId]);


  return (
    <div className="pagebackground">
      <NavigationBar />
      <PageTitle title={articleTitle} />
      <div className="newsarticlebackground">

            <div dangerouslySetInnerHTML={{ __html: articleHtml }} className="articleContent"/>
      </div>
    </div>
  );
};

export default Newsarticle;
